import React from 'react';
import { BsArrowRight } from 'react-icons/bs';
import Sme from '../../assets/svgs/sme.svg';
import Culture2 from '../../assets/svgs/cs5.svg';
import Sme1 from '../../assets/images/sme13.png';
import Sme3 from '../../assets/images/sme15.png';
import Sme4 from '../../assets/images/sme12.png';

import Logo1 from '../../assets/images/course1.png';
import Logo3 from '../../assets/images/course3.png';
import Logo2 from '../../assets/images/course2.png';
import Button from '../../components/inputs/Button';

function LeadershipSchool() {
  return (
    <section className="relative mb-28 sm:mb-52 mt-20">
      <div className="content">
        <img src={Logo1} alt="" className="hidden lg:block w-32 h-auto right-24 absolute" />
        <div className="md-2:flex relative">
          <div className="w-full mb-10 md-2:w-[calc(100%-500px)] md-2:mb-0 flex">
            <div className="w-full text-center md-2:pr-14 md-2:text-left">
              <h1 className="section-header">Schools</h1>
              <p className="font-semibold text-[#032A48]">SME Business School</p>
              <p className="big-p mb-5 md:mb-0 mt-5">
                SME Business School is aimed at driving economic growth.
                This school offers tailored educational programs
                designed specifically for the unique challenges and opportunities faced by SMEs.
                The school equips entrepreneurs with the knowledge and skills necessary
                to effectively manage and grow their businesses.
              </p>
              <Button
                paddingY="py-2.5"
                className="bg-primary text-white mt-5"
              >
                <a className="flex gap-3 items-center" href="https://docs.google.com/forms/d/e/1FAIpQLSfpPnSNzKNXm5RrChtYCDLJwCbOlocWhrG9PBoTb2xZVZx0Qw/viewform" target="_blank" rel="noreferrer">
                  <p>Apply Now</p>
                  <BsArrowRight />
                </a>
              </Button>

            </div>
          </div>
          <div className="w-full sm:w-[500px] mx-auto">
            <div className="w-full h-[400px] sm:h-[500px] flex space-x-4">
              <div className="w-2/3 bg-gray-300 relative overflow-hidden">
                <img src={Sme1} alt="Caring and Sharing" className="interactive-picture" />
              </div>
              <div className="w-1/3 h-full flex flex-wrap space-y-4">
                <div className="w-full h-[calc(50%-16px)] bg-[#032A48] overflow-hidden">
                  <img src={Sme} alt="" className="" />
                </div>
                <div className="w-full h-1/2 bg-gray-300 relative overflow-hidden">
                  <img src={Sme3} alt="Caring and Sharing" className="interactive-picture" />
                </div>
              </div>
            </div>
            <div className="w-full h-[250px] lg:h-[280px] sm:h-[220px] flex space-x-4 mt-4">
              <div className="w-2/3 bg-gray-300 relative overflow-hidden">
                <img src={Sme4} alt="Caring and Sharing" className="interactive-picture" />
              </div>
              <div className="w-2/3 h-full flex flex-wrap space-y-4">
                <div className="w-full h-full overflow-hidden">
                  <img src={Culture2} alt="" className="" />
                </div>
              </div>
            </div>
          </div>
          <div className="">
            <img src={Logo3} alt="" className="hidden lg:block w-32 h-32 absolute -left-48 mt-[520px] object-contain" />
          </div>
          <div className="">
            <img src={Logo2} alt="" className="hidden lg:block w-32 h-32 absolute -right-36 mt-[660px] object-contain" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default LeadershipSchool;
